import { set } from 'lodash';
import produce from 'immer';
import CONST from '../_actions';

const initialState = {
  columnPreferences: {},
  loading: false,
  fileManager: {
    show: false,
    removeFile: null,
    addFile: null,
    selectedFiles: []
  }
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case CONST.LOADER_START:
      return produce(state, draftState => {
        set(draftState, 'loading', true);
      });

    case CONST.LOADER_STOP:
      return produce(state, draftState => {
        set(draftState, 'loading', false);
      });

    case CONST.SET_COLUMN_PREFERENCES:
      return produce(state, draftState => {
        set(draftState, ['columnPreferences', payload.path], payload.columns);
      });

    case CONST.UPDATE_FILE_MANAGER:
      return produce(state, draftState => {
        set(draftState, 'fileManager', {
          ...draftState.fileManager,
          ...payload
        });
      });

    default:
      return state;
  }
};
